// extracted by mini-css-extract-plugin
export default {"createPatientSubLabel":"CreatePatientPopup_createPatientSubLabel__j3T23","footer":"CreatePatientPopup_footer__ZQLIP"};